"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _styledPrice = require("./styled-price");
var _excluded = ["price", "dataTestId", "headingTag", "isEuro", "prevPrice", "saving", "showCurrentFrom", "showPreviousFrom", "showSave", "size"];
/* Price */
/* Displays a price. This includes sale and range */
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  price: _propTypes["default"].number.isRequired,
  dataTestId: _propTypes["default"].string,
  headingTag: _propTypes["default"].string,
  isEuro: _propTypes["default"].bool,
  prevPrice: _propTypes["default"].number,
  saving: _propTypes["default"].number,
  showCurrentFrom: _propTypes["default"].bool,
  showPreviousFrom: _propTypes["default"].bool,
  showSave: _propTypes["default"].bool,
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['xxs', 'xs', 's', 'm', 'l']), _propTypes["default"].shape({
    xxs: _propTypes["default"].string,
    xs: _propTypes["default"].string,
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string,
    xl: _propTypes["default"].string,
    xxl: _propTypes["default"].string
  })])
};
var defaultProps = {
  dataTestId: null,
  headingTag: 'h3',
  isEuro: false,
  prevPrice: 0,
  saving: 0,
  showCurrentFrom: false,
  showPreviousFrom: false,
  showSave: true,
  size: 'l'
};
var basicPriceConfig = _config.priceConfig.basicPrice,
  prevPriceConfig = _config.priceConfig.prevPrice,
  savePriceConfig = _config.priceConfig.savePrice;
var Price = forwardRef(function (_ref, ref) {
  var price = _ref.price,
    dataTestId = _ref.dataTestId,
    headingTag = _ref.headingTag,
    isEuro = _ref.isEuro,
    prevPrice = _ref.prevPrice,
    saving = _ref.saving,
    showCurrentFrom = _ref.showCurrentFrom,
    showPreviousFrom = _ref.showPreviousFrom,
    showSave = _ref.showSave,
    size = _ref.size,
    others = _objectWithoutProperties(_ref, _excluded);
  var formattedPrice = (0, _fuseUtils.formatPrice)(price);
  var formattedPrevPrice = (0, _fuseUtils.formatPrice)(prevPrice);
  var formattedSavePrice = (0, _fuseUtils.formatPrice)(saving);
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 1),
    isResponsive = _buildResponsiveSize2[0];
  var getResponsiveFontSize = function getResponsiveFontSize(config) {
    if (isResponsive) {
      var processedSize = {};
      Object.keys(size).forEach(function (viewport) {
        processedSize[viewport] = config.font.size[size[viewport]];
      });
      return processedSize;
    }
    return config.font.size[size];
  };
  var getPriceText = function getPriceText(priceNum, showFrom) {
    var isSave = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var saveText = showFrom ? 'Save up to ' : 'Save ';
    var fromText = showFrom ? 'From ' : '';
    var currency = isEuro ? '€' : '£';
    var prefix = isSave ? saveText : fromText;
    return "".concat(prefix).concat(currency).concat(priceNum);
  };
  return /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledPriceContainer, _extends({
    "data-testid": dataTestId,
    ref: ref
  }, others), !!price && !prevPrice && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledBasicPrice, {
    tag: headingTag,
    size: getResponsiveFontSize(basicPriceConfig),
    type: basicPriceConfig.font.type,
    "data-testid": dataTestId && "".concat(dataTestId, "__basic")
  }, getPriceText(formattedPrice, showCurrentFrom)), !!price && !!prevPrice && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledSalePriceWrapper, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledBasicPrice, {
    prevPrice: formattedPrevPrice,
    size: getResponsiveFontSize(basicPriceConfig),
    type: basicPriceConfig.font.type,
    tag: headingTag,
    "data-testid": dataTestId && "".concat(dataTestId, "__basic")
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, "Current sale price is "), getPriceText(formattedPrice, showCurrentFrom)), showSave && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledSavePrice, {
    size: getResponsiveFontSize(savePriceConfig),
    type: savePriceConfig.font.type,
    "data-testid": dataTestId && "".concat(dataTestId, "__save")
  }, "(", getPriceText(formattedSavePrice, showCurrentFrom, true), ")")), !!prevPrice && /*#__PURE__*/_react["default"].createElement(_styledPrice.StyledPrevPrice, {
    size: getResponsiveFontSize(prevPriceConfig),
    type: prevPriceConfig.font.type,
    "data-testid": dataTestId && "".concat(dataTestId, "__prev")
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, "Regular price was "), getPriceText(formattedPrevPrice, showPreviousFrom)));
});
Price.propTypes = propTypes;
Price.defaultProps = defaultProps;
var _default = exports["default"] = Price;